var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeEnvelopeFechadoPreto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 12,
    viewBox: "0 0 24 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline",
    transform: "translate(-2 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_497_",
    d: "M26,6.4A2.407,2.407,0,0,0,23.6,4H4.4A2.407,2.407,0,0,0,2,6.4V20.8a2.407,2.407,0,0,0,2.4,2.4H23.6A2.407,2.407,0,0,0,26,20.8Zm-2.4,0L14,12.388,4.4,6.4Zm0,14.4H4.4V8.8l9.6,6,9.6-6Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeEnvelopeFechadoPreto);
export default __webpack_public_path__ + "static/media/icone-envelope-fechado-preto.9b0d02a6b80904e3c0e303fa585a5bc0.svg";
export { ForwardRef as ReactComponent };